import { render, staticRenderFns } from "./Wish.vue?vue&type=template&id=2c4c96b9"
import script from "./Wish.vue?vue&type=script&lang=js"
export * from "./Wish.vue?vue&type=script&lang=js"
import style0 from "./Wish.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports